/**
 * An on/off switch that saves on its own (no Save button). A native button, so Space and Enter
 * toggle it; `labelId` and `descriptionId` point at the row text that names and explains it.
 */
export function Switch({
  checked,
  onChange,
  labelId,
  descriptionId,
  disabled,
}: {
  checked: boolean;
  onChange: (next: boolean) => void;
  labelId: string;
  descriptionId?: string;
  disabled?: boolean;
}) {
  return (
    <button
      type="button"
      role="switch"
      className="switch"
      aria-checked={checked}
      aria-labelledby={labelId}
      aria-describedby={descriptionId}
      disabled={disabled}
      onClick={() => onChange(!checked)}
    >
      <span className="switch-track" aria-hidden="true">
        <span className="switch-thumb" />
      </span>
    </button>
  );
}
